import { heroStats } from '@/mocks/homeData';

export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-[72px] overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 w-full max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-sm font-medium mb-5">
              <i className="ri-fire-line"></i>
              <span>全网热播中</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-4">
              香蕉影视
              <span className="block text-primary-600 text-2xl md:text-3xl lg:text-4xl mt-2">
                热门综艺娱乐免费高清在线观看
              </span>
            </h1>

            <p className="text-foreground-600 text-base md:text-lg leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              全网最新最热综艺娱乐一站式平台，覆盖搞笑综艺、真人秀、脱口秀、音乐竞技、美食探店等多元内容。
              每日更新50+优质节目，高清片源秒开不缓冲，手机电脑电视多端同步，
              随时随地轻松看，让快乐触手可及。当前热播《喜剧之王争霸》第三季、《明星大冒险》沙漠特辑，精彩不容错过。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {heroStats.map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => scrollTo('#cards')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-play-circle-fill mr-2"></i>立即观看
              </button>
              <button
                onClick={() => scrollTo('#index')}
                className="w-full sm:w-auto px-8 py-3 border border-background-300 text-foreground-700 hover:bg-background-100 font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-grid-line mr-2"></i>浏览专题
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20entertainment%20TV%20studio%20set%20with%20colorful%20warm%20lighting%2C%20multiple%20screens%20displaying%20variety%20shows%2C%20modern%20broadcast%20equipment%2C%20energetic%20atmosphere%2C%20professional%20production%20environment%2C%20warm%20orange%20and%20golden%20ambient%20glow%2C%20cinematic%20composition&width=1200&height=900&seq=hero-main&orientation=landscape"
                alt="香蕉影视综艺娱乐平台主视觉"
                className="w-full h-full object-cover"
                title="香蕉影视 - 综艺娱乐免费高清在线观看"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <div className="flex items-center gap-2 text-background-50 text-xs">
                  <span className="px-2 py-1 bg-primary-500/90 rounded text-xs font-medium">正在热播</span>
                  <span>喜剧之王争霸 · 第三季</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}